import React, {useContext} from 'react';

export const AnvilProps = React.createContext(undefined);

/**
 * Share props passed into the react-habitat HOC.
 *
 * The top level component that is registered with react-habitat should pass its props to the AnvilProps.Provider.
 * @example
 * function SomeReactHabitatHOC(props) {
 *     return (
 *         <AnvilProps.Provider value={props}>
 *             <SomeChildComponent/>
 *         </AnvilProps.Provider>
 *     )
 * }
 *
 * Then descendant components can access the original props using the hook.
 * @example
 * function SomeChildComponent() {
 *     const anvilProps = useAnvilProps();
 *     return (
 *         <h1>
 *             {anvilProps.title}
 *         </h1>
 *     )
 * }
 */
export function useAnvilProps() {
    return useContext(AnvilProps);
}
